import {gql} from "@apollo/client";
import {ReportStatusInquiryInput} from "../../domain";
import {getDomainGraphqlError, useMutation$} from "graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";

const GRAPHQL_MUTATION = gql`
    mutation submitAuthReportStatusInquiry($input: AuthReportStatusInquiryInput) {
        submitAuthReportStatusInquiry(input: $input) {
            guid
        }
    }
`;

type AuthReportStatusInquiryInput = ReportStatusInquiryInput & {
    authorizationGuid: string;
};

const sanitizePayload = (
    formValues: ReportStatusInquiryInput,
    authorizationGuid: string
): AuthReportStatusInquiryInput => {
    return {
        reportType: formValues.reportType || "",
        reportStatusInquiry: formValues.reportStatusInquiry || "",
        additionalDetails: formValues.additionalDetails || "",
        authorizationGuid,
    };
};

export function useAuthReportStatusInquiry(authorizationGuid: string) {
    const {execute} = useMutation$<{ input: AuthReportStatusInquiryInput }, void>(GRAPHQL_MUTATION);
    const submitReportStatusInquiry = useCallback(async function (formValues: ReportStatusInquiryInput | null) {
            if (formValues == null) {
                return;
            }

            try {
                await execute({
                    variables: {
                        input: sanitizePayload(formValues, authorizationGuid),
                    },
                });
                showToast.success(
                    'Report Status Inquiry request successfully submitted. The Request can be tracked in the "Submitted Requests" section and a request number ID will be available shortly.'
                );
            } catch (errors: any) {
                if (getDomainGraphqlError(errors)) {
                    showToast.error(getDomainGraphqlError(errors));
                } else {
                    showToast.error(`Unable to submit Report Status Inquiry: ${errors.message || errors[0]?.message}`);
                }
            }
        },
        [authorizationGuid, execute]
    );

    return {
        submitReportStatusInquiry,
    };
}
